<template>
    <div class="question-container">
      <datepicker
        class="questionnaire-date"
        :language="nl"
        v-model="message"
        :name="'question' + question.id.toString()" placeholder="Selecteer datum"
      />
      <span class="questionnaire-error-text" v-if="$v.message.$error">Dit is een verplicht veld.</span>
      <statement-field
        v-if="question.typeable !== 'undefined' && question.typeable.statement"
        @updated="statementUpdated"
      />
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { nl } from 'vuejs-datepicker/dist/locale'
import { EventBus } from '../EventBus'
import { requiredUnless } from 'vuelidate/lib/validators'
import StatementField from './StatementField'

export default {
  name: 'DateQuestion',
  components: {
    Datepicker,
    StatementField
  },
  props: {
    question: {
      type: Object,
      default: null
    }
  },

  validations: {
    message: {
      required: requiredUnless('isOptional')
    }
  },

  computed: {
    isOptional () {
      return !this.question.typeable.required
    }
  },

  methods: {
    touch () {
      this.$v.$touch()
      let parsedAnswer = { 'id': this.question.id, answer: { questionId: this.question.id, answer: this.message, statement: this.statement }, ranged: false, valid: !this.$v.$invalid }
      this.$emit('updated', parsedAnswer)
    },
    statementUpdated (newStatement) {
      this.statement = newStatement
      this.$emit('statementUpdated', { questionId: this.question.id, statement: this.statement })
    }
  },

  watch: {
    message (newMessage) {
      this.$v.$touch()

      let parsedAnswer = { 'id': this.question.id, answer: { questionId: this.question.id, answer: newMessage, statement: this.statement }, ranged: false, valid: !this.$v.$invalid }
      this.$emit('updated', parsedAnswer)
    }
  },

  data () {
    return {
      nl,
      statement: null,
      message: null
    }
  },
  created () {
    EventBus.$on('validate', this.touch)
  },
  beforeDestroy () {
    EventBus.$off('validate', this.touch)
  }
}
</script>
